import { render, staticRenderFns } from "./error-feedback.vue?vue&type=template&id=6a4c41aa&scoped=true&"
import script from "./error-feedback.vue?vue&type=script&lang=js&"
export * from "./error-feedback.vue?vue&type=script&lang=js&"
import style0 from "./error-feedback.vue?vue&type=style&index=0&id=6a4c41aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4c41aa",
  null
  
)

export default component.exports